// extracted by mini-css-extract-plugin
export default {"text":"NotificationReceivers_text__GG75z","tags":"NotificationReceivers_tags__trP9Z","title":"NotificationReceivers_title__QyfiJ"};